var _defs, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIappLogoColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 693.9092822 255.6913292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#radial-gradient-3);\n      }\n\n      .cls-4 {\n        fill: gray;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 389.4955504,
    cy: 71.3737879,
    fx: 389.4955504,
    fy: 71.3737879,
    r: 393.9210805,
    gradientTransform: "translate(.1168161 88.6670043) rotate(-4.6639) scale(1 .2021)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.057486,
    stopColor: "#0184e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140892,
    stopColor: "#0071c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3028814,
    stopColor: "#005192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4617745,
    stopColor: "#003766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6140669,
    stopColor: "#024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7580681,
    stopColor: "#00132b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8903374,
    stopColor: "#000b1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000818"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 286.5960206,
    cy: 78.134619,
    fx: 286.5960206,
    fy: 78.134619,
    r: 489.8012906,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -3.7399713,
    cy: 90.4343013,
    fx: -3.7399713,
    fy: 90.4343013,
    r: 260.2289464,
    gradientTransform: "translate(7.4919157 14.7032936) rotate(5.63616) scale(1 .845564)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.179391,
    stopColor: "#0184e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375411,
    stopColor: "#007fdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3255764,
    stopColor: "#0072c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4325816,
    stopColor: "#005ea6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5544576,
    stopColor: "#004176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6871192,
    stopColor: "#001d3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757567,
    stopColor: "#000818"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m558.251798,95.1404298c-2.0147657-7.1971799-5.9280813-13.5838625-11.9202568-18.9613741-3.542219-3.1816233-7.6289463-5.5681959-12.0104501-7.3351331h91.4361583c16.7697465,0,29.1651443,3.6038275,37.1598323,10.7802346,4.8722156,4.372779,8.2704449,9.5526819,10.1776434,15.5162726h-114.8429271Zm-168.3272207,0h163.4931774c-1.9071985-5.9627029-5.3125296-11.1504179-10.1776434-15.5162726-7.9861939-7.168595-20.3883103-10.8173417-37.1598079-10.7802346l-137.9640488.2957915,21.8083227,26.0007156Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m517.7507287,185.7240441v-32.7419575c10.3857272-1.1806805,20.7732299-4.2774369,28.5582642-11.1555667,6.4949855-5.7459194,10.4879937-12.7367909,12.3380224-20.6198307h66.4583128c7.0776639,0,11.849211-.962299,14.2904677-2.8590223,2.4412567-1.8960131,3.6757336-4.6545444,3.6757336-8.2487845,0-2.3017056-.5322827-4.2575517-1.6055479-5.8709117h33.0817796c.2480317,1.8908643.3744444,3.8465329.3744444,5.8709117,0,11.7597555-4.0050813,21.183184-12.0051237,28.2582123-7.9998649,7.0741405-20.4124565,10.6163597-37.1598323,10.6163597h-77.4664888v36.7505898h-30.540032Zm-200.6753805-42.7012196h63.4865216l-29.7978899-38.7948538h36.8287091l63.3338321,81.4960734h-37.5671227l-13.8847809-18.0770177h-101.2063554l18.8070862-24.6242019h0Zm28.6621286-45.3383095h36.7715393l-20.4369579-26.2965072h-32.3396376l-89.0201132,114.3360363h37.5673002c22.433462-29.3774619,44.9335036-58.7107149,67.4578691-88.0395292h0Zm-106.5742576,82.4929939v-92.6654887l30.5425176-17.544735v70.9802048l-30.5425176,39.2300189h0Zm182.7700501-39.3063637l30.5434053,39.3010373v-31.1987282h53.6036288c16.7471738,0,29.1684652-3.5518066,37.1598079-10.6163597,7.9947161-7.0663285,12.0051237-16.4984567,12.0051237-28.2582123,0-2.0243788-.1248148-3.9800474-.3744444-5.8709117h-33.0766308c1.0663409,1.61336,1.5986484,3.5692061,1.5986484,5.8709117,0,3.5942401-1.2346792,6.3527714-3.6741604,8.2487845-2.4394812,1.8967233-7.2110283,2.8590223-14.2903175,2.8590223h-100.1002225l16.6051614,19.664456Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m76.0334414,162.771794l-5.9496835-10.30678h-32.6429902l-9.4012222-16.2831069v-.012779l-9.0524687-15.6794342,9.0524687-15.6804172v-.0138713l9.4012222-16.2825607h32.6078205l5.9848531-10.3660878v-.012779l6.7895902-11.7600944-10.536147-18.254682h-13.8091079v-9.0472263h19.0073336l13.1541007,22.779442h26.4944257l13.1542099-22.779442h19.0077705v9.0472263h-13.8095448l-10.536147,18.254682,6.7906895,11.7600944v.012779l5.9837538,10.3660878h32.6109941l9.4017622,16.2825607v.0138713l9.0524687,15.6804172-9.0524687,15.6794342v.012779l-9.4017622,16.2831069h-32.6451807l-5.9495672,10.30678v.012779l-9.4017622,16.2832161h-36.9042023l-9.4012091-16.2832161v-.012779h0Zm17.7266929,34.2322935h20.2510581l-10.1254785,19.6152665-10.1255797-19.6152665h0Zm26.9563276-12.9883013l-4.3112299,8.3506053h-25.0385992l-4.311776-8.3506053h33.6616052Zm-38.3681113-63.5564561l-6.3149093-10.9383044v-.0138713l-6.8979531-11.9471926h-26.48962l-6.6242345,11.461917-6.620084,11.4678151,6.6258789,11.4641015,6.6184396,11.4641015h26.4555425l6.9320305-12.0070465v-.012779l6.3149093-10.9387413h0Zm1.3989216-15.6500533l6.4220636,11.1259487h27.409164l6.4514445-11.1259487v-.0138713l6.3405921-10.9825395-5.4888752-9.4972229-7.7480246-13.4171088h-26.4944257l-6.6242345,11.4614801-6.6104724,11.4506671,6.3427681,10.984724v.0138713h0Zm47.9933427,26.6015737l6.9320234,12.0070465h26.45871l6.6242345-11.460934,6.6199748-11.4672689-6.6258728-11.4646476-6.6194287-11.4650845h-26.4928966l-6.8967446,11.9471926v.0138713l-6.3154625,10.9383044,6.3154625,10.9387413v.012779h0Zm-54.3179799,15.7274921l6.5982468,11.4171358,6.6183292,11.4641015h26.495518l6.6237976-11.460934,6.5944167-11.4235799-6.3229989-10.9531587v-.012779l-6.4584347-11.1862395h-27.3770526l-.14188.2645369-6.3053048,10.9217026v.012779l-6.3246372,10.9564354Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 205.0434153,
    y: 73.414365,
    width: 1.0458053,
    height: 108.8625992
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIappLogoColor);
export default __webpack_public_path__ + "static/media/IAPPLogoColor.7ebf006404fa919daf2017fe0181b65d.svg";
export { ForwardRef as ReactComponent };